import StorageAbstractFactory from '@infrastructure/cache';
/**
 * Decorate the instance adding and interceptor for
 * checking if session is expired
 *
 * @param {import('axios').AxiosInstance} instance
 * @returns {import('axios').AxiosInstance}
 *
 * @author Jose Aburto <pino0071@gmail.com>
 */
export default function sessionExpirationCheckInterceptor(instance) {
  const onFulfilled = val => Promise.resolve(val);
  const onRejected = error => {
    const storage = StorageAbstractFactory.getSyncGlobalInstance();
    if (error.response && error.response.status) {
      if ([401, 403].includes(error.response.status)) {
        storage.removeItem('token');
        storage.removeItem('principal');
        const loginPath = window.location.origin + '/login';
        window.location.replace(loginPath);
      }
    }
    return Promise.reject(error);
  };

  instance.interceptors.response.use(onFulfilled, onRejected);
  return instance;
}
